export default {
      id: "241,8=1,7+70+70+35+28,4+35+1,7-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#241,8=1,7+70+70+35+28,4+35+1,7",
      toString: function () {
        return this.url;
      }
    }